import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Input } from "./ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

// Selector de categoría/industria con catálogo compartido; si se escribe una nueva, el backend la agrega al listado.
export function IndustrySelect({ value, onChange, testid = "industry" }) {
  const [opts, setOpts] = useState([]);
  useEffect(() => { api.get("/catalogs/industries").then((r) => setOpts(r.data || [])).catch(() => setOpts([])); }, []);
  const inList = opts.includes(value);
  const sel = inList ? value : (value ? "Otra" : "");
  return (
    <div className="space-y-1.5">
      <Select value={sel} onValueChange={(v) => onChange(v === "Otra" ? " " : v)}>
        <SelectTrigger className="rounded-sm" data-testid={testid}><SelectValue placeholder="Selecciona categoría" /></SelectTrigger>
        <SelectContent>
          {opts.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}
          <SelectItem value="Otra">Otra…</SelectItem>
        </SelectContent>
      </Select>
      {(!inList && value !== "") && <Input className="rounded-sm" placeholder="Escribe la categoría" value={value.trim()} onChange={(e) => onChange(e.target.value)} data-testid={`${testid}-other`} />}
    </div>
  );
}

export default IndustrySelect;
